import React, { useEffect, useState } from "react";
import * as Account from '../../account';
import * as api from '../../services/api';
import * as auth from '../../services/auth';
import * as qbd from '../../services/qbd';
import TopNavbar from "../../shares/TopNavbar";
import { greeting, locale } from "../../utils";
import ServiceStatus from "../../shares/ServiceStatus";
import { PublicComplianceFooter } from "../../shares/PublicSiteChrome";
import qboConnectButton from "../../images/Connect_to_QuickBooks_buttons/Connect_to_QuickBooks_English/Connect_to_QuickBooks_SVG/C2QB_green_btn_med_default.svg";

const FORA_LOGIN_URL = "https://gofora.net/";

function AlertBanner({ tone, title, message, onClose }) {
    if (!message) {
        return null;
    }

    const styles = tone === "error"
        ? {
            shell: "border-red-200 bg-white/95 text-red-900 shadow-red-100/80",
            icon: "bg-red-100 text-red-600",
            text: "text-red-700",
            button: "text-red-500 hover:bg-red-50 hover:text-red-700 focus:ring-red-300",
        }
        : {
            shell: "border-amber-200 bg-white/95 text-amber-900 shadow-amber-100/80",
            icon: "bg-amber-100 text-amber-600",
            text: "text-amber-700",
            button: "text-amber-500 hover:bg-amber-50 hover:text-amber-700 focus:ring-amber-300",
        };

    return (
        <div className="fixed inset-x-0 top-3 z-50 px-3 sm:top-4 sm:px-4">
            <div className={`mx-auto flex max-w-3xl items-start gap-3 rounded-2xl border px-3 py-2.5 shadow-xl backdrop-blur ${styles.shell}`}>
                <div className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${styles.icon}`}>
                    {tone === "error" ? (
                        <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0 3.75h.008v.008H12v-.008zm8.25-.75a8.25 8.25 0 11-16.5 0 8.25 8.25 0 0116.5 0z" />
                        </svg>
                    ) : (
                        <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8.25v4.5m0 3h.008v.008H12v-.008zm8.25-.75a8.25 8.25 0 11-16.5 0 8.25 8.25 0 0116.5 0z" />
                        </svg>
                    )}
                </div>
                <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold tracking-tight">{title}</p>
                    <p className={`mt-0.5 text-sm leading-5 ${styles.text}`}>{message}</p>
                </div>
                <button
                    id="close-error"
                    type="button"
                    className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition focus:outline-none focus:ring-2 ${styles.button}`}
                    onClick={onClose}
                    aria-label={`Dismiss ${title.toLowerCase()}`}
                >
                    <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default function Home(props) {

    var account = Account.getUserAccount()

    let intervalId = null;
    const [selectedPlatform, setSelectedPlatform] = useState(new URLSearchParams(window.location.search).get("platform") || localStorage?.getItem('selected_platform') || "quickbooks_online");

    const [foraCompany, setForaCompany] = useState(null);
    const [QBOCompany, setQBOCompany] = useState(null);
    const [QBDCompany, setQBDCompany] = useState(null);
    const [QBDWorks, setQBDWorks] = useState(false);
    const [CNTWorks, setCNTWorks] = useState(false);
    const [QBFCWorks, setQBFCWorks] = useState(false);
    const [QBWorks, setQBWorks] = useState(false);
    const [foraWorks, setForaWorks] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [warningMessage, setWarningMessage] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    /** True until QuickBooks Online link is checked (avoids Connect flash after OAuth callback). */
    const [qboCheckPending, setQboCheckPending] = useState(
        () => selectedPlatform === "quickbooks_online"
    );
    /** True after Connect click until redirect or error. */
    const [qboOAuthPending, setQboOAuthPending] = useState(false);
    const [uploading, setUploading] = useState("");
    const [csvFiles, setCsvFiles] = useState([]);
    const customerFolder = csvFiles.find(folder => folder.folderName === "customer");
    const customerFiles = customerFolder && customerFolder.files.length > 0 ? customerFolder.files[0] : null;
    const productFolder = csvFiles.find(folder => folder.folderName === "product");
    const productFiles = productFolder && productFolder.files.length > 0 ? productFolder.files[0] : null;

    const checkForaWorks = () => {
        setLoading(true)
        api.getHealth()
            .then(response => {
                setForaWorks(response.success)
                if (response.model)
                    setForaCompany(response.model)
            })
            .catch(err => {
                console.log(err)
                setForaWorks(false)
            }).finally(_ => {
                setLoading(false)
            })
    }


    const checkQBWorks = () => {
        if (QBWorks) {
            setQboCheckPending(false)
            return
        }

        api.quickBooksCompanyInfo()
            .then(response => {
                if (response && response.CompanyName)
                    setQBWorks(true)

                setQBOCompany(response)
            })
            .catch(err => {
                setQBWorks(false)
            }).finally(_ => {
                setQboCheckPending(false)
            })
    }


    useEffect(() => {
        if (!(account && account.user))
            return

        checkForaWorks()
    }, [])

    const connectQuickBooks = () => {
        setQboOAuthPending(true)
        auth.connectQuickBooks()
            .then(response => {
                // Keep pending until navigation; do not clear on success.
                window.location.href = response.url;
            })
            .catch(err => {
                console.log(err)
                setError(err)
                setQboOAuthPending(false)
            })
    }

    const disconnectQuickBooks = () => {
        if (
            window.confirm(
                `Disconnect "${QBOCompany.CompanyName}" from Fora Connector?`
            )
        ) {
            window.location.href = "/disconnect?platform=quickbooks_online"
        }
    }

    const checkRequiredApp = () => {
        setLoading(true)
        qbd.checkQB()
            .then(response => {
                if (response.success)
                    setQBDWorks(true)
                else
                    setQBDWorks(false)
            })
            .catch(err => {
                setQBDWorks(false)
                console.log(err)
                setError(err)
            }).finally(_ => { setLoading(false) })


        qbd.checkConnector()
            .then(response => {
                if (response.success)
                    setCNTWorks(true)
                else
                    setCNTWorks(false)
            })
            .catch(err => {
                setCNTWorks(false)
                console.log(err)
                setError(err)
            }).finally(_ => { setLoading(false) })

        qbd.checkQBFCWorks()
            .then(response => {
                if (response.success)
                    setQBFCWorks(true)
                else
                    setQBFCWorks(false)
            })
            .catch(err => {
                setQBFCWorks(false)
                console.log(err)
                setError(err)
            }).finally(_ => { setLoading(false) })
    }


    const connectQuickBooksDesktop = () => {
        setQBDCompany(null)
        setLoading(true)
        qbd.connect().then(response => {
            setWarningMessage("")
            setErrorMessage("")
            setQBDCompany(response)
            window.localStorage.removeItem(Account.quickBooksDesktopLocalKey)
            clearInterval(intervalId);
        }).catch(err => {
            setError(err)
            checkRequiredApp()
        }).finally(_ => {
            setLoading(false)
        })

    };

    const disconnectQuickBooksDesktop = () => {
        if (
            window.confirm(
                `Disconnect "${QBDCompany.companyName}" from Fora Connector?`
            )
        ) {
            window.location.href = "/disconnect?platform=quickbooks_desktop"
        }
    }


    function handleOptionChange(e) {
        var { name, value } = e.target
        setSelectedPlatform(value)
        const url = new URL(window.location.href);
        url.searchParams.set("platform", value);
        window.history.replaceState({}, "", url);
    }

    useEffect(() => {
        if (!error)
            return


        if (error.data && error.data.error) {
            if (warningMessage) {
                setErrorMessage("Fora Connector cannot make a connection with QuickBooks.  Please make sure QuickBooks is running and try again.")
                return
            }
            var err = error.data.error.replace(
                'If the QuickBooks company data file is not open, a call to the "BeginSession" method must include the name of the data file.',
                "Please make sure QuickBooks is running to proceed."
            ).replace(
                "The application trying to connect to QuickBooks is not supported while multiple instances of QuickBooks are running.",
                "When you have QuickBooks open more than one on the same machine, Fora Connector might have trouble connecting. Close one of the QuickBooks by going to file and clicking exit and try again."
            ).replace(
                "Could not start QuickBooks",
                "Please make sure QuickBooks is running to proceed."
            )
            setWarningMessage(err)
            return
        }

        if (error.data && Object.keys(error.data).length !== 0) {
            setErrorMessage(JSON.stringify(error.data))
            return
        }

        if (error && Object.keys(error).length !== 0) {
            setErrorMessage(JSON.stringify(error))
            return
        }

    }, [error])

    useEffect(() => {
        if (selectedPlatform)
            localStorage.setItem('selected_platform', selectedPlatform);

        if (selectedPlatform == "quickbooks_online") {
            setQboCheckPending(true)
            checkQBWorks()
        } else {
            setQboCheckPending(false)
        }

        if (selectedPlatform == "quickbooks_desktop") {
            checkRequiredApp()
            if (!window.localStorage.getItem(Account.quickBooksDesktopLocalKey))
                connectQuickBooksDesktop()
        }

        if (selectedPlatform == "csv") {
            loadCsvFiles()
        }

    }, [selectedPlatform])

    const loadCsvFiles = () => {
        api.csv().then(response => {
            setCsvFiles(response)
        }).catch(err => {
            console.log(err)
        }).finally(_ => {
            setUploading("")
        })
    }

    const isCsvPlatform = selectedPlatform === "csv";
    const heroDescription = isCsvPlatform
        ? "Move customer, product, and sales-order data between CSV files and the Fora Mobile Commerce Platform with a single connector for connection, mapping, and job monitoring."
        : "Move customer, product, and sales-order data between QuickBooks workflows and the Fora Mobile Commerce Platform with a single connector for connection, mapping, and job monitoring.";
    const publicInfoTitle = isCsvPlatform
        ? "CSV details, pricing, support, and policy links"
        : "QuickBooks details, pricing, support, and policy links";
    const publicInfoDescription = isCsvPlatform
        ? "This site explains what Fora Connector does for CSV workflows and where to find pricing, support, privacy, and terms before going live."
        : "This site explains what Fora Connector does, how QuickBooks Online and QuickBooks Desktop connections work, and where to find pricing, support, privacy, and terms before going live.";
    const learnMoreHref = isCsvPlatform ? "/learn-more/csv" : "/learn-more";
    const syncSummary = isCsvPlatform
        ? "Customers, products, and sales orders between Fora and CSV files."
        : "Customers, products, and sales orders between Fora and the selected accounting workflow.";

    return (
        <>

            <AlertBanner
                tone="warning"
                title="Warning"
                message={!errorMessage ? warningMessage : ""}
                onClose={() => setWarningMessage("")}
            />
            <AlertBanner
                tone="error"
                title="Error"
                message={errorMessage}
                onClose={() => {
                    setErrorMessage("");
                    setWarningMessage("");
                }}
            />

            <div className="min-h-full">
                <ServiceStatus
                    platform={selectedPlatform}
                    selectedModel={"customer"}
                    foraWorks={foraWorks}
                    foraCompany={foraCompany}
                    account={account}
                    csvFile={customerFiles || productFiles}
                    QBDCompany={QBDCompany}
                    QBOCompany={QBOCompany}
                />
                <TopNavbar />

                <main className="container mx-auto px-4 flex flex-col items-center justify-center mt-4">
                    <h1 className="font-bold text-4xl text-gray-900 mb-3">Welcome to Fora Connector</h1>
                    <p className="text-gray-700 text-base mb-4 text-center max-w-3xl">
                        {heroDescription}
                    </p>

                    <section className="w-full max-w-5xl rounded-2xl border border-slate-700 bg-slate-900 px-5 py-4 text-white shadow-lg shadow-slate-900/20 sm:px-6 mb-5">
                        <div className="grid gap-4 lg:grid-cols-[1.5fr_1fr] lg:items-center">
                            <div className="min-w-0">
                                <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-300">Public app info</p>
                                <p className="mt-1 text-base font-semibold text-white">
                                    {publicInfoTitle}
                                </p>
                                <p className="mt-1 text-sm text-slate-200">
                                    {publicInfoDescription}
                                </p>
                                <div className="mt-3 flex flex-wrap gap-2">
                                    <a
                                        href={learnMoreHref}
                                        className="inline-flex min-w-[132px] items-center justify-center rounded-lg bg-white px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
                                    >
                                        Learn more
                                    </a>
                                    <a
                                        href="#public-info-footer"
                                        className="inline-flex min-w-[132px] items-center justify-center rounded-lg border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-white transition hover:border-white/25 hover:bg-white/10"
                                    >
                                        More information
                                    </a>
                                </div>
                            </div>

                            <div className="flex flex-col gap-3">
                                <div className="rounded-xl border border-white/10 bg-white/5 px-4 py-3">
                                    <p className="text-sm font-semibold text-white">What it syncs</p>
                                    <p className="mt-1 text-sm text-slate-200">
                                        {syncSummary}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>


                    <div className="min-h-screen w-100">
                        <div className="max-w-4xl mx-auto py-4">
                            <h1 className="text-4xl font-bold text-gray-900 mb-8">Dashboard</h1>
                            <div className="space-y-6">
                                <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                    <div className="w-4/6">
                                        <h2 className="font-bold text-gray-900">{account && account.user ? "Signed in Fora Connector" : "Sign in Fora Connector"}</h2>
                                        <span className="flex mt-2 w-full">
                                            <p className="text-gray-700 font-light">{greeting()}</p>
                                            <p className="ml-2 text-gray-700 font-bold">{account && account.user ? `${account.user.Name}` : "Complete sigin on the Fora Connector."}</p>
                                        </span>
                                    </div>
                                    <div className="flex">
                                        {account ?
                                            <svg className="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            :
                                            <a
                                                className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2 inline-block"
                                                href="/signin"
                                            >
                                                Sign in
                                            </a>
                                        }

                                    </div>
                                </div>
                                {account && account.user ? <>
                                    <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                        <div className="w-4/6">
                                            <h2 className="font-bold text-gray-900">Connect with Fora Mobile Commerce Platform</h2>
                                            <p className="mt-2 text-gray-700">
                                                {loading
                                                    ? "Checking Fora Mobile Commerce Platform connection..."
                                                    : foraWorks && foraCompany?.name
                                                    ? `Connected to Fora Mobile Commerce Platform (${foraCompany.name}).`
                                                    : "Invalid API key. Go to gofora.net and click Fora Connector in the side menu again."}
                                            </p>
                                            {!loading && !foraWorks && (
                                                <a
                                                    href={FORA_LOGIN_URL}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="mt-2 inline-flex text-sm font-semibold text-slate-700 underline decoration-2 underline-offset-2 hover:text-slate-900"
                                                >
                                                    Open gofora.net
                                                </a>
                                            )}
                                        </div>
                                        {loading ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                            </svg>
                                        ) : (
                                            foraWorks ? (
                                                <svg className="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            ) : null
                                        )}

                                    </div>
                                    {account && account.user ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Select platform</h2>
                                                {/* <p className="mt-2 text-gray-700">Now we offer support for QuickBooks and CSV </p> */}
                                            </div>
                                            <div className="w-2/6">
                                                <div className="relative ml-4">
                                                    <select name="platform" value={selectedPlatform} onChange={handleOptionChange} className="w-full appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" id="select-option">
                                                        <option value="quickbooks_online">QuickBooks Online</option>
                                                        <option value="quickbooks_desktop">QuickBooks Desktop</option>
                                                        <option value="csv">CSV </option>
                                                    </select>
                                                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                            <path d="M10 12l-5-5 1.41-1.41L10 9.17l3.59-3.58L15 7z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null}
                                    {selectedPlatform == "quickbooks_desktop" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4">
                                            <div className="bg-white items-center flex justify-between">
                                                <div className="w-4/6">
                                                    <h2 className="font-bold text-gray-900">Application required</h2>
                                                    <p className="mt-2 text-gray-700">If you don't already have both applications, you will need to download Fora Connector and QuickBooks Desktop</p>
                                                </div>
                                                <div>
                                                    {CNTWorks && QBDWorks && QBFCWorks ? null : <button onClick={e => { checkRequiredApp() }} className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Check</button>}
                                                </div>
                                            </div>
                                            <div className="pt-4 bg-white items-center flex justify-between">
                                                <div className="w-4/6">
                                                    <span className="flex mt-2">
                                                        <p className="text-gray-700">Fora Connector desktop app {CNTWorks ? "is already running." : "is not running."}</p>
                                                    </span>
                                                </div>
                                                {loading ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                    </svg>
                                                    : CNTWorks ?
                                                        <div className="flex">
                                                            <button onClick={e => { checkRequiredApp() }}>
                                                                <svg className="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        :
                                                        <div className="flex">
                                                            <a target="_blank" className="font-bold" href="https://s3.ap-northeast-1.amazonaws.com/logiciel.printserver/connector/ForaConnector.msi">Download</a>
                                                        </div>
                                                }

                                            </div>
                                            <div className="pt-4 bg-white items-center flex justify-between">
                                                <div className="w-4/6">
                                                    <span className="flex mt-2">
                                                        <p className="text-gray-700">QuickBooks Foundation Class (QBFC16) {QBFCWorks ? "is already installed." : " is not installed."}</p>
                                                    </span>
                                                </div>

                                                {loading ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                    </svg>
                                                    :
                                                    QBFCWorks ?
                                                        <div className="flex">
                                                            <button onClick={e => { checkRequiredApp() }}>
                                                                <svg className="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        :
                                                        CNTWorks ? <div className="flex">
                                                            <button className="font-bold" onClick={_ => qbd.launchInstallQBFC()}>Install</button>
                                                        </div> : null
                                                }

                                            </div>
                                            <div className="bg-white items-center flex justify-between mt-4">
                                                <div className="w-4/6">
                                                    <span className="flex mt-2">
                                                        <p className="text-gray-700">QuickBooks Enterprise solutions {QBDWorks ? "is already running." : "is not running."}</p>
                                                    </span>
                                                </div>
                                                {loading ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                    </svg>
                                                    :
                                                    QBDWorks ?
                                                        <div className="flex">
                                                            <button onClick={e => { checkRequiredApp() }}>
                                                                <svg className="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        :
                                                        CNTWorks ?
                                                            // <div className="flex">
                                                            //     <a target="_blank" className="font-bold" href="https://downloads.quickbooks.com/app/qbdt/products?productName=QuickBooks%20Desktop%20Enterprise&edition=&version=23&country=us">download</a>
                                                            // </div> 
                                                            <a href="#" className="font-bold" onClick={e => {
                                                                qbd.launchQB().finally(_ => setTimeout(checkRequiredApp, 1000))
                                                            }}>
                                                                <button>Launch QuickBooks</button>
                                                            </a>
                                                            : null
                                                }

                                            </div>
                                        </div> : null}


                                    {selectedPlatform == "quickbooks_desktop" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Connect with QuickBooks Desktop</h2>
                                                <p className="mt-2 text-gray-700">
                                                    {QBDCompany?.companyName
                                                        ? `Connected to QuickBooks Desktop (${QBDCompany.companyName}).`
                                                        : "If you don't already have one, you will need to sign up for QuickBooks Desktop to use Fora Connector."}
                                                </p>
                                            </div>
                                            {loading ?
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                </svg>
                                                : account && account.user ?
                                                    <div className="flex">
                                                        {QBDCompany ?
                                                            <span className="flex">
                                                                <button
                                                                    type="button"
                                                                    title="Ends the desktop link, then opens reconnect instructions."
                                                                    onClick={() => disconnectQuickBooksDesktop()}
                                                                    className="whitespace-nowrap font-bold bg-gray-50 text-red-500 border-2 border-red-500 rounded-lg px-4 py-2 mr-2"
                                                                >
                                                                    Disconnect From QuickBooks
                                                                </button>
                                                            </span>

                                                            :
                                                            CNTWorks && QBDWorks && QBFCWorks ? <button onClick={e => { connectQuickBooksDesktop() }} >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="223" height="36" viewBox="0 0 223 36" fill="none">
                                                                    <rect width="223" height="36" rx="4" fill="#2CA01C" />
                                                                    <path d="M35.3116 14.112C34.4156 12.928 32.6716 12.384 31.1996 12.384C27.7116 12.384 25.0556 14.672 25.0556 18.304C25.0556 21.84 27.5676 24.288 31.1036 24.288C33.0236 24.288 34.4956 23.552 35.4876 22.304L33.8716 21.168C33.2956 21.952 32.3356 22.48 31.1196 22.48C28.7836 22.48 27.2796 20.768 27.2796 18.304C27.2796 15.968 28.8636 14.16 31.1996 14.16C32.1116 14.16 33.1836 14.512 33.7756 15.328L35.3116 14.112ZM36.0087 20.128C36.0087 22.544 37.8647 24.224 40.1847 24.224C42.5047 24.224 44.3607 22.544 44.3607 20.128C44.3607 17.712 42.5047 16.096 40.1847 16.096C37.8647 16.096 36.0087 17.712 36.0087 20.128ZM37.9607 20.128C37.9607 18.928 38.6647 17.664 40.1847 17.664C41.7047 17.664 42.4087 18.928 42.4087 20.128C42.4087 21.328 41.7047 22.624 40.1847 22.624C38.6647 22.624 37.9607 21.328 37.9607 20.128ZM46.2223 24H48.1423V19.776C48.1423 18.752 48.7183 17.696 49.9343 17.696C51.1663 17.696 51.3743 18.832 51.3743 19.744V24H53.2943V19.2C53.2943 17.632 52.4623 16.096 50.4623 16.096C49.3263 16.096 48.4143 16.784 48.0783 17.552H48.0463V16.32H46.2223V24ZM55.5348 24H57.4548V19.776C57.4548 18.752 58.0308 17.696 59.2468 17.696C60.4788 17.696 60.6868 18.832 60.6868 19.744V24H62.6068V19.2C62.6068 17.632 61.7748 16.096 59.7748 16.096C58.6388 16.096 57.7268 16.784 57.3908 17.552H57.3588V16.32H55.5348V24ZM66.3193 19.392C66.3993 18.32 67.3113 17.536 68.4473 17.536C69.6953 17.536 70.2553 18.4 70.2553 19.392H66.3193ZM72.1753 20.256C72.1753 17.488 70.6073 16.096 68.4633 16.096C66.1433 16.096 64.3993 17.728 64.3993 20.208C64.3993 22.704 66.1593 24.224 68.5273 24.224C69.9833 24.224 71.0713 23.712 71.8233 22.688L70.5433 21.664C70.1113 22.272 69.4713 22.656 68.5113 22.656C67.3913 22.656 66.3993 21.856 66.3193 20.768H72.1593C72.1753 20.592 72.1753 20.432 72.1753 20.256ZM80.5948 17.296C79.9868 16.544 78.8188 16.096 77.6988 16.096C75.4428 16.096 73.5868 17.664 73.5868 20.16C73.5868 22.72 75.4748 24.224 77.7468 24.224C78.8828 24.224 79.9388 23.84 80.5788 23.152L79.3788 21.936C79.0108 22.384 78.3548 22.624 77.7628 22.624C76.3068 22.624 75.5868 21.36 75.5868 20.16C75.5868 18.96 76.2908 17.696 77.6988 17.696C78.3228 17.696 78.9788 18.016 79.2828 18.448L80.5948 17.296ZM82.0873 17.856V21.44C82.0873 22.912 82.5513 24.16 84.5833 24.16C85.0153 24.16 85.5273 24.08 85.8633 23.952L85.7993 22.448C85.5753 22.56 85.2393 22.608 84.9833 22.608C84.1353 22.608 83.9753 22.112 83.9753 21.424V17.856H85.8953V16.32H83.9753V14.096H82.0873V16.32H80.7433V17.856H82.0873ZM91.5248 17.856V21.44C91.5248 22.912 91.9888 24.16 94.0208 24.16C94.4528 24.16 94.9648 24.08 95.3008 23.952L95.2368 22.448C95.0128 22.56 94.6768 22.608 94.4208 22.608C93.5728 22.608 93.4128 22.112 93.4128 21.424V17.856H95.3328V16.32H93.4128V14.096H91.5248V16.32H90.1808V17.856H91.5248ZM96.2743 20.128C96.2743 22.544 98.1303 24.224 100.45 24.224C102.77 24.224 104.626 22.544 104.626 20.128C104.626 17.712 102.77 16.096 100.45 16.096C98.1303 16.096 96.2743 17.712 96.2743 20.128ZM98.2263 20.128C98.2263 18.928 98.9303 17.664 100.45 17.664C101.97 17.664 102.674 18.928 102.674 20.128C102.674 21.328 101.97 22.624 100.45 22.624C98.9303 22.624 98.2263 21.328 98.2263 20.128ZM122.792 22.368H119.992V22.336C121 21.616 122.008 20.224 122.008 18.192C122.008 14.752 119.464 12.384 115.992 12.384C112.52 12.384 109.928 14.752 109.928 18.192C109.928 21.872 112.344 24 115.96 24H122.792V22.368ZM115.992 14.192C118.28 14.192 119.816 15.888 119.816 18.192C119.816 20.608 118.2 22.24 115.96 22.24C113.688 22.24 112.136 20.608 112.136 18.192C112.136 15.888 113.8 14.192 115.992 14.192ZM131.121 16.32H129.201V20.544C129.201 21.568 128.625 22.624 127.409 22.624C126.177 22.624 125.969 21.488 125.969 20.576V16.32H124.049V21.12C124.049 22.688 124.881 24.224 126.881 24.224C128.017 24.224 128.929 23.536 129.265 22.768H129.297V24H131.121V16.32ZM133.457 24H135.377V16.32H133.457V24ZM133.185 13.712C133.185 14.32 133.697 14.864 134.401 14.864C135.105 14.864 135.649 14.368 135.649 13.712C135.649 13.056 135.105 12.56 134.401 12.56C133.697 12.56 133.185 13.104 133.185 13.712ZM144.267 17.296C143.659 16.544 142.491 16.096 141.371 16.096C139.115 16.096 137.259 17.664 137.259 20.16C137.259 22.72 139.147 24.224 141.419 24.224C142.555 24.224 143.611 23.84 144.251 23.152L143.051 21.936C142.683 22.384 142.027 22.624 141.435 22.624C139.979 22.624 139.259 21.36 139.259 20.16C139.259 18.96 139.963 17.696 141.371 17.696C141.995 17.696 142.651 18.016 142.955 18.448L144.267 17.296ZM145.551 24H147.471V20.064H147.519L150.559 24H153.103L149.567 19.792L152.895 16.32H150.431L147.519 19.552H147.471V11.904H145.551V24ZM154.303 24H158.383C160.527 24 162.671 23.168 162.671 20.704C162.671 19.184 161.647 18.224 160.223 18.032V18C161.391 17.648 162.191 16.8 162.191 15.52C162.191 13.456 160.431 12.672 158.719 12.672H154.303V24ZM156.319 14.336H157.935C159.455 14.336 160.175 14.736 160.175 15.744C160.175 16.72 159.455 17.28 158.111 17.28H156.319V14.336ZM156.319 19.008H158.207C159.839 19.008 160.655 19.424 160.655 20.608C160.655 22.096 159.167 22.304 158.127 22.304H156.319V19.008ZM164.118 20.128C164.118 22.544 165.974 24.224 168.294 24.224C170.614 24.224 172.47 22.544 172.47 20.128C172.47 17.712 170.614 16.096 168.294 16.096C165.974 16.096 164.118 17.712 164.118 20.128ZM166.07 20.128C166.07 18.928 166.774 17.664 168.294 17.664C169.814 17.664 170.518 18.928 170.518 20.128C170.518 21.328 169.814 22.624 168.294 22.624C166.774 22.624 166.07 21.328 166.07 20.128ZM173.884 20.128C173.884 22.544 175.74 24.224 178.06 24.224C180.38 24.224 182.236 22.544 182.236 20.128C182.236 17.712 180.38 16.096 178.06 16.096C175.74 16.096 173.884 17.712 173.884 20.128ZM175.836 20.128C175.836 18.928 176.54 17.664 178.06 17.664C179.58 17.664 180.284 18.928 180.284 20.128C180.284 21.328 179.58 22.624 178.06 22.624C176.54 22.624 175.836 21.328 175.836 20.128ZM184.129 24H186.049V20.064H186.097L189.137 24H191.681L188.145 19.792L191.473 16.32H189.009L186.097 19.552H186.049V11.904H184.129V24ZM198.147 17.264C197.523 16.48 196.371 16.096 195.267 16.096C193.747 16.096 192.211 16.832 192.211 18.544C192.211 19.984 193.347 20.448 194.483 20.72C195.651 20.992 196.243 21.184 196.243 21.824C196.243 22.512 195.571 22.736 195.011 22.736C194.179 22.736 193.459 22.32 193.043 21.776L191.779 22.96C192.515 23.776 193.747 24.224 194.931 24.224C196.611 24.224 198.131 23.536 198.131 21.664C198.131 20.16 196.787 19.648 195.651 19.376C194.579 19.12 193.987 18.96 193.987 18.368C193.987 17.76 194.611 17.536 195.219 17.536C195.923 17.536 196.563 17.92 196.899 18.368L198.147 17.264Z" fill="white" />
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </div> : null
                                            }

                                        </div>
                                        : null}

                                    {selectedPlatform == "quickbooks_online" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Connect with QuickBooks Online</h2>
                                                <p className="mt-2 text-gray-700">
                                                    {QBWorks && QBOCompany?.CompanyName
                                                        ? `Connected to QuickBooks Online (${QBOCompany.CompanyName}).`
                                                        : "If you don't already have one, you will need to sign up for a QuickBooks Online account to use Fora Connector."}
                                                </p>
                                            </div>
                                            {qboCheckPending || qboOAuthPending ?
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                </svg>
                                                :
                                                <div className="flex">
                                                    {QBWorks && QBOCompany ?
                                                        <span className="flex">
                                                            <button
                                                                type="button"
                                                                title="Revokes QuickBooks Online access, then opens reconnect instructions."
                                                                onClick={() => disconnectQuickBooks()}
                                                                className="whitespace-nowrap font-bold bg-gray-50 text-red-500 border-2 border-red-500 rounded-lg px-4 py-2 mr-2"
                                                            >
                                                                Disconnect From QuickBooks
                                                            </button>
                                                        </span>
                                                        :
                                                        <button
                                                            type="button"
                                                            onClick={() => connectQuickBooks()}
                                                            title="Sign in with Intuit to authorize QuickBooks Online (opens in this window)"
                                                            aria-label="Connect to QuickBooks Online"
                                                        >
                                                            <img
                                                                src={qboConnectButton}
                                                                alt="Connect to QuickBooks Online"
                                                                className="h-9 w-auto"
                                                            />
                                                        </button>
                                                    }
                                                </div>
                                            }

                                        </div> : null}


                                    <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex flex-col space-y-6">
                                        <div className="flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Mapping</h2>
                                                {selectedPlatform == "csv"}
                                                <p className="mt-2 text-gray-700">{selectedPlatform == "csv" ?
                                                    `Provide sample CSV (Comma-Separated Values) file with column title 
                                            for importing Customer and Product info to Fora. These files are for 
                                            mapping data fields between the import CSV and Fora.`
                                                    : `Review the field names in ${locale(selectedPlatform)} and 
                                            Fora Mobile Commerce Platform to ensure you are using the same names for the fields you want to map.`} </p>
                                            </div>
                                            {account && account.user ?
                                                <div className="flex">
                                                    <a href={`/mapping?platform=${selectedPlatform}`} className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Start</a>
                                                </div> : null}
                                        </div>
                                    </div>

                                    {selectedPlatform == "quickbooks_online" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Run job</h2>
                                                <p className="mt-2 text-gray-700">
                                                    Select the job you want to run and monitor it to confirm data is
                                                    transferring correctly between QuickBooks Online and the Fora Mobile
                                                    Commerce Platform.
                                                </p>
                                            </div>
                                            {account && account.user && QBWorks && foraWorks ?
                                                <div className="flex">
                                                    <a href="/jobs" className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Start</a>
                                                </div> : null}
                                        </div> : null}

                                    {selectedPlatform == "quickbooks_desktop" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Run Desktop process</h2>
                                                <p className="mt-2 text-gray-700">Select the process you want to run between QuickBooks Desktop and Fora Mobile Commerce Platform </p>
                                            </div>
                                            {account && account.user && QBDWorks && CNTWorks && foraWorks && QBDCompany && QBFCWorks ?
                                                <div className="flex">
                                                    <a href="/jobs/desktop" className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Start</a>
                                                </div> : null}
                                        </div> : null}

                                    {selectedPlatform == "csv" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Export Field Selection</h2>
                                                <p className="mt-2 text-gray-700">Please select the fields you want to include before exporting your order.</p>
                                            </div>
                                            {account && account.user ?
                                                <div className="flex">
                                                    <a href={`/mapping?platform=${selectedPlatform}&model=${'order'}`} className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Start</a>
                                                </div> : null}
                                        </div> : null}

                                    {selectedPlatform == "csv" ?
                                        <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                            <div className="w-4/6">
                                                <h2 className="font-bold text-gray-900">Run CSV Import or Export</h2>
                                                <p className="mt-2 text-gray-700">Select the process you want to run between CSV and Fora Mobile Commerce Platform or Export orders</p>
                                            </div>
                                            {account && account.user && foraWorks && (customerFiles?.length > 0 || productFiles?.length > 0) ?
                                                <div className="flex">
                                                    <a href="/jobs/csv" className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">Start</a>
                                                </div> : null}
                                        </div> : null}

                                    <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                        <div className="w-4/6">
                                            <h2 className="font-bold text-gray-900">Logs</h2>
                                            <p className="mt-2 text-gray-700">{`Result between ${locale(selectedPlatform)}  and Fora Mobile Commerce Platform`} </p>
                                        </div>
                                        <div className="flex">
                                            {account && account.user ? <a href={`/logs?platform=${selectedPlatform}`} className="bg-gray-50 text-gray-500 border-2 border-gray-500 font-bold rounded-lg px-4 py-2 mr-2">View</a> : null}
                                        </div>
                                    </div></> : null}
                            </div>
                        </div>
                    </div>

                    <div id="public-info-footer" className="w-full max-w-5xl scroll-mt-24 pb-12">
                        <PublicComplianceFooter />
                    </div>
                </main>
            </div>

        </>


    )
}
